import React from "react";

export const PreviewRow: React.FC<{
  label: string;
  value: string;
  hideDivider?: boolean;
}> = ({ label, value, hideDivider }) => {
  return (
    <>
      {value ? (
        <span className="jugl__break-word line-clamp-4 text-sm leading-[21px] text-dark-900">
          {value}
        </span>
      ) : (
        <span className="font-secondary text-sm leading-[21px] text-dark-800">
          {label}
        </span>
      )}
      {!hideDivider && (
        <div className="my-4 h-px w-full rounded-[10px] bg-dark-100" />
      )}
    </>
  );
};
